import { Injectable } from "@angular/core";

import {
    CanActivate,
    CanActivateChild,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router
} from "@angular/router";

import { AuthenticationService } from "./authentication.service";

@Injectable()
export class AuthenticationGuard implements CanActivate, CanActivateChild {

    constructor(
        private _router: Router,
        private _authenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        const user = this._authenticationService.authenticatedUser;
        
        if (!user) {
            this._router.navigate(['/account/signin'], { queryParams: { returnUrl: state.url } });
            return false;
        }

        if(route.data.role !== undefined && route.data.role !== user.role) {
            this._router.navigateByUrl("/");
            return false;
        }

        return true;
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivate(childRoute, state);
    }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/services/authentication-guard.service.ts